import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { setCookie } from '../../functions/Auth';

import '../../scss/_styles.scss';
import '../../scss/components/_externalLayers.scss';

const ExternalLayers = (props) => {

    const [itemsLayer, setItemsLayer] = useState([]);
    const [showColors, setShowColors] = useState(false);
    const [showMoreOptions, setShowMoreOptions] = useState(false);

    useEffect(() => {
        if(props.customLayers.length > 0) {
            sortLayers();
        }
    }, [props.customLayers]);

    const sortLayers = () => {
        // sort items to show in sidebar
        let arr = props.customLayers;
        arr.sort(function(a, b) {
            var x = parseInt(a["order"]); var y = parseInt(b["order"]);
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }); 
        setItemsLayer(arr);
        // set cookie for external layers
        let cookieLayers = [];
        arr.forEach(function(layer){
            cookieLayers.push({layerName: layer.layerName, visible: layer.visible})
        })
        sessionStorage.setItem('externalLayers',JSON.stringify(cookieLayers));
    }

    const handleMoreOptions = () => {
        setShowMoreOptions(!showMoreOptions);
    }

    return (
        
        <>
        {
            props.showExternalLayers &&
            <div data-testid="externalLayersContainer" className="main-layers-container">
                {
                    !showColors &&
                    <>
                        <p>External layers</p>
                        <IconButton aria-label="delete" className='btn-close-xtl' onClick={props.handleShowLayersContainer}>
                            <img src={require("../../assets/icons/close-external-leyer.svg")} />  
                        </IconButton>
                        {/* <SortableList items={itemsLayer} distance={5} onSortEnd={onSortEnd} /> */}
                        <div className="main-layers-list" data-testid="layersList">
                            {
                                itemsLayer.map( (layer, ind) => (
                                    <div>
                                        <input 
                                            type="checkbox" 
                                            checked={layer.visible} 
                                            onChange={(e)=>props.handleLayerVisibility(e, ind)} 
                                            id={layer.layerName}
                                        />
                                        <label for={layer.layerName}>{layer.layerName}</label>
                                    </div>
                                ))
                            }
                        </div>
                        <p className="divisor"></p>
                        <div className="center-text"><Button className="light-blue-btn" onClick={props.clearAllExternalLayers}>Clear layers</Button></div>
                    </>
                }
            </div>
        }
        </>
    )
    
}

export default ExternalLayers;